import React, { useState } from 'react';
import Navbar from '../../components/Navbar';

export default function Payment() {
  const [txnId, setTxnId] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!txnId.trim()) return;
    setSubmitted(true);
  };

  return (
    <div className="pi">
      <Navbar module="consult" />

      <div className="sh">
        <span className="ey ey-r">✦ Official QR Payment Portal ✦</span>
        <h1>Registration & <em>Membership</em> Payment</h1>
        <p>
          QR payments are received directly by host <strong>Laxmikant Timilsina</strong> (Tansen-09, Palpa) for registration verification and account privacy activation.
        </p>
      </div>

      <div className="sec" style={{ maxWidth: '960px' }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
          gap: '2rem',
          alignItems: 'start'
        }}>
          {/* Left Column: Packages & Details */}
          <div>
            {/* Registration Fee Card */}
            <div className="card card-lg" style={{ marginBottom: '1.5rem', borderLeft: '4px solid var(--gold)' }}>
              <span className="tag" style={{ background: 'var(--gold-l)', color: 'var(--gold-d)', marginBottom: '0.6rem' }}>
                Step 1: Account Registration
              </span>
              <h3 style={{ fontFamily: 'var(--serif)', fontSize: '1.6rem', fontWeight: 700, color: 'var(--deep)' }}>
                Registration Verification
              </h3>
              <div style={{ fontFamily: 'var(--serif)', fontSize: '2.5rem', fontWeight: 700, color: 'var(--rose)', margin: '0.4rem 0' }}>
                NPR 1,500 <span style={{ fontSize: '0.9rem', color: 'var(--muted)', fontFamily: 'var(--sans)' }}>one-time</span>
              </div>
              <p style={{ fontSize: '0.85rem', color: 'var(--mid)', lineHeight: 1.6, marginBottom: '1rem' }}>
                Activates your profile in our confidential matrimonial registry hosted by Laxmikant Timilsina. Includes background check & privacy shield setup.
              </p>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.4rem' }}>
                <span className="tag">✓ Verified Profile Badge</span>
                <span className="tag">✓ Contact Privacy Toggles</span>
                <span className="tag">✓ Kundali Evaluation</span>
              </div>
            </div>

            {/* Full Package Card */}
            <div className="card card-lg" style={{ borderLeft: '4px solid var(--rose)' }}>
              <span className="tag" style={{ background: 'var(--rose-l)', color: 'var(--rose-d)', marginBottom: '0.6rem' }}>
                Step 2: Full Matchmaking Access
              </span>
              <h3 style={{ fontFamily: 'var(--serif)', fontSize: '1.6rem', fontWeight: 700, color: 'var(--deep)' }}>
                6-Month Premium Matchmaking
              </h3>
              <div style={{ fontFamily: 'var(--serif)', fontSize: '2.5rem', fontWeight: 700, color: 'var(--rose)', margin: '0.4rem 0' }}>
                NPR 5,000 <span style={{ fontSize: '0.9rem', color: 'var(--muted)', fontFamily: 'var(--sans)' }}>for 6 months</span>
              </div>
              <p style={{ fontSize: '0.85rem', color: 'var(--mid)', lineHeight: 1.6, marginBottom: '1rem' }}>
                Full access to introduce profiles, schedule family meetings, and direct consultation with Laxmikant Timilsina in Tansen, Palpa or Butwal.
              </p>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.4rem' }}>
                <span className="tag">✓ Unlimited Matches</span>
                <span className="tag">✓ Dedicated Counselor</span>
                <span className="tag">✓ Family Meetup Support</span>
              </div>
            </div>
          </div>

          {/* Right Column: QR Code & Submission */}
          <div>
            <div className="card card-lg" style={{ textAlign: 'center' }}>
              <span className="ey ey-r" style={{ marginBottom: '0.4rem' }}>Scan & Pay via eSewa / Fonepay</span>
              <h3 style={{ fontFamily: 'var(--serif)', fontSize: '1.5rem', fontWeight: 700, marginBottom: '0.8rem' }}>
                Payment Recipient
              </h3>

              {/* QR Code Container */}
              <div className="qr-box" style={{ marginBottom: '1.2rem' }}>
                <div style={{
                  background: 'linear-gradient(135deg, #1E1716, #3B121A)',
                  color: '#F7D070',
                  padding: '0.4rem 0.8rem',
                  borderRadius: '8px',
                  fontSize: '0.78rem',
                  fontWeight: 700,
                  marginBottom: '1rem',
                  letterSpacing: '0.05em'
                }}>
                  eSewa / Khalti / Fonepay QR
                </div>

                {/* SVG Simulated QR Graphic */}
                <svg width="180" height="180" viewBox="0 0 180 180" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ margin: '0 auto' }}>
                  <rect width="180" height="180" rx="12" fill="#FFFFFF" stroke="#E8DFD1" strokeWidth="2" />
                  {/* Position Detection Patterns */}
                  <rect x="14" y="14" width="44" height="44" rx="6" fill="#1E1716" />
                  <rect x="22" y="22" width="28" height="28" rx="3" fill="#FFFFFF" />
                  <rect x="28" y="28" width="16" height="16" rx="2" fill="#9E1B32" />

                  <rect x="122" y="14" width="44" height="44" rx="6" fill="#1E1716" />
                  <rect x="130" y="22" width="28" height="28" rx="3" fill="#FFFFFF" />
                  <rect x="136" y="28" width="16" height="16" rx="2" fill="#9E1B32" />

                  <rect x="14" y="122" width="44" height="44" rx="6" fill="#1E1716" />
                  <rect x="22" y="130" width="28" height="28" rx="3" fill="#FFFFFF" />
                  <rect x="28" y="136" width="16" height="16" rx="2" fill="#9E1B32" />

                  {/* Matrix Random QR Data Modules */}
                  <path d="M70 14h10v10H70zM90 14h10v10H90zM70 34h20v10H70zM100 34h10v20h-10zM70 54h10v20H70zM90 64h20v10H90zM14 70h20v10H14zM44 70h10v20H44zM70 90h30v10H70zM110 90h10v20h-10zM130 70h20v10h-20zM140 90h20v10h-20zM70 110h10v20H70zM90 110h20v10H90zM120 120h40v10h-40zM14 110h10v10H14zM70 140h10v30H70zM90 140h30v10H90zM130 140h30v20h-30z" fill="#1E1716" />

                  {/* Center Emblem */}
                  <circle cx="90" cy="90" r="16" fill="#C59B27" stroke="#FFFFFF" strokeWidth="2" />
                  <text x="90" y="94" textAnchor="middle" fill="#FFFFFF" fontSize="10" fontWeight="bold">VIVAH</text>
                </svg>

                <div style={{ marginTop: '0.8rem', fontSize: '1.2rem', fontWeight: 700, color: 'var(--rose)' }}>
                  9857074103
                </div>
                <div style={{ fontSize: '0.85rem', fontWeight: 600, color: 'var(--deep)' }}>
                  Recipient Name: <strong>Laxmikant Timilsina</strong>
                </div>
                <div style={{ fontSize: '0.75rem', color: 'var(--muted)', marginTop: '0.2rem' }}>
                  Address: Tansen-09, Palpa, Nepal
                </div>
              </div>

              {/* Transaction ID Submission Form */}
              {submitted ? (
                <div className="al al-ok" style={{ textAlign: 'left' }}>
                  <strong>✓ Transaction Received!</strong>
                  <p style={{ fontSize: '0.82rem', marginTop: '0.3rem' }}>
                    Thank you! Host <strong>Laxmikant Timilsina</strong> is verifying your transaction (ID: <code>{txnId}</code>). Your account will be activated within 1 hour. You can also send a screenshot to <strong>9857074103</strong> on WhatsApp.
                  </p>
                </div>
              ) : (
                <form onSubmit={handleSubmit} style={{ textAlign: 'left' }}>
                  <div className="fg">
                    <label>Enter Payment Transaction ID / Reference No.</label>
                    <input
                      type="text"
                      placeholder="e.g. 84920491823"
                      value={txnId}
                      onChange={(e) => setTxnId(e.target.value)}
                      required
                    />
                  </div>
                  <button type="submit" className="btn btn-rose btn-blk">
                    Submit Transaction ID for Activation →
                  </button>
                  <p style={{ fontSize: '0.74rem', color: 'var(--muted)', textAlign: 'center', marginTop: '0.6rem' }}>
                    Need instant activation? Call or WhatsApp <strong>9857074103</strong> directly.
                  </p>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
